/**
 * Converts seconds to a human-readable time string.
 * @param {number} props.seconds - The number of seconds to convert
 * @return {ReactElement} The formatted time as a string
 */
const ReadableTime = ({ seconds }) => {
    function convertSecondsToReadableString(secondsToConvert) {
        secondsToConvert = secondsToConvert || 0;
        secondsToConvert = Number(secondsToConvert);
        secondsToConvert = Math.abs(secondsToConvert);

        const d = Math.floor(secondsToConvert / (3600 * 24));
        const h = Math.floor((secondsToConvert % (3600 * 24)) / 3600);
        const m = Math.floor((secondsToConvert % 3600) / 60);
        const s = Math.floor(secondsToConvert % 60);
        const parts = [];

        if (d > 0) {
            parts.push(d + 'd');
            return parts.join(', ');
        }

        if (h > 0) {
            parts.push(h + 'h');
            if (m > 0) {
                parts.push(m + 'm');
            }
            return parts.join(' ');
        }

        if (m > 0) {
            parts.push(m + 'm');
        }

        if (s > 0 || parts.length === 0) {
            parts.push(s + 's');
        }

        return parts.join(' ');
    }

    return <>{convertSecondsToReadableString(seconds)}</>;
};

export default ReadableTime;
